import React, { Component } from 'react'
import DatePickerMulti from 'react-multi-date-picker'
import {
  Button,
  UncontrolledCollapse,
  CustomInput,
  Card,
  CardBody,
  InputGroup,
  Input,
  InputGroupAddon,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Collapse,
  Popover,
  PopoverHeader,
  PopoverBody,
  Table,
} from 'reactstrap'
import {
  tools,
  filtersData,
  toolkitCategoryFilterMapping,
  getDisplayByKey,
  getTypeByKey,
  getAppliedFiltersCount,
  toolkitCategoryFilterValues,
  addToolStep,
  getSubcategories,
  canAddToGroup,
  whiteLabelStyling,
  displayEventDates,
  UserRole,
  privacyLabel,
  MAX_DISTANCE_OPTIONS,
  removePhraseBetweenCommas,
  renderGenderPronoun,
  baseUrl,
  uploadPreview,
  checkValidationOfModule,
  navigate_user_to_module,
} from './../../utils/constants'
import axios from '../../axios'
import favoritedIcon from './../../assets/heartFilled.png'
import * as url from '../../utils/url'
import { withRouter, useNavigate } from 'react-router-dom'
import * as actionCreators from './../../modules/actions/index'
import {
  toolkitCategories,
  initialToolDetailsState,
} from '../../utils/categories'
import moment from 'moment'
import placeholder from './../../assets/toolkit-favorite-placeholder.svg'
import Tooltip from '../../components/UI/TooltipIcon/TooptipIcon'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import union from 'lodash/union'
import uniqBy from 'lodash/uniqBy'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import reverse from 'lodash/reverse'
import size from 'lodash/size'
import { filter } from 'lodash'
import isEmpty from 'lodash/isEmpty'
import Select from 'react-select'
import { connect } from 'react-redux'
import Checkbox from 'rc-checkbox'
import Loading from '../../hoc/Loading/Loading'
import { socketConnection } from '../../socketClient'
import { deepClone } from './../../utils/copyObject'
import './Toolkit.css'
import 'rc-checkbox/assets/index.css'
// import 'react-select/dist/react-select.css';
import EmptyTable from '../../components/EmptyTable/EmptyTable'
import AddToGroup from '../../components/AddToGroup/AddToGroup'
import communityIcon from './../../assets/privacy-icon-offices-below.svg'
import slackLogo from '../../assets/icons/Slack-Small.png'
import teamsLogo from '../../assets/icons/Teams-Small.png'
import SlackSharePopup from '../../components/SlackAndTeamsPopups/SlackSharePopup'
import TeamsSharePopup from '../../components/SlackAndTeamsPopups/TeamsSharePopup'
import TurndownService from 'turndown'
import { gfm } from 'turndown-plugin-gfm'
import {
  BiUserPlus,
  BiMailSend,
  BiCopy,
  BiLogoSlack,
  BiLogoMicrosoftTeams,
} from 'react-icons/bi'
import { toastContainer } from '../../utils/toast'
import AutocompleteAddress from '../../components/AddressSearch/AutocompleteAddress'
import { filterToolFocus } from '../../utils/filterToolData'
import { BiDownArrowAlt, BiUpArrowAlt } from 'react-icons/bi'
import { orderBy } from 'lodash'
import { isNumber } from 'lodash'

class ToolkitCategory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSlackShare: false,
      showTeamsShare: false,
      selectedToolToShare: null,
      //category of the toolkit page
      toolkitCategory: '',
      address: '',
      // all tools fetched from the server
      allTools: [],

      dropdownOpen: false,

      //tools selected by the user from the table
      selectedTools: [],
      menu: 0,
      selectedResource: null,

      dateSort: 1,
      nameSort: null,
      //applied filters
      filters: {},
      dropdownItmOpen: null,
      toolCount: 0,

      //tools currently displayed in the table
      displayTools: [],

      //value user has entered in the search box
      searchedTerm: '',

      //
      selectedSort: 'last-updated',

      //
      isFilterCollapsed: false,

      categoryDefinitionPopoverOpen: false,

      columns: [
        { key: 'name', value: 'Name' },
        { key: 'createdBy', value: 'Privacy' },
        // {key:'category',value:'Category'},
        { key: 'subCategory', value: 'Subcategory' },
        { key: 'diversity_focus', value: 'Diversity' },
        { key: 'relevant_for', value: 'Aimed at' },
        { key: 'address', value: 'Address' },
        // {key:'lastUpdate',value:'Updated'}
      ],
      diversityFocusOptions: [],
      relevantForOptions: [],
      sortParams: {
        sortBy: '',
        sortOrder: '',
      },
    }

    this.favoriteColumns = [
      { key: 'name', value: 'Name' },
      // {key:'category',value:'Category'},
      { key: 'createdBy', value: 'Created by' },
      { key: 'lastUpdate', value: 'Last Updated' },
    ]

    this.columns = [
      { key: 'name', value: 'Name' },
      { key: 'createdBy', value: 'Privacy' },
      // {key:'category',value:'Category'},
      { key: 'subCategory', value: 'Subcategory' },
      { key: 'diversity_focus', value: 'Diversity' },
      { key: 'relevant_for', value: 'Aimed at' },
      { key: 'address', value: 'Address' },
      // {key:'lastUpdate',value:'Updated'}
    ]
  }

  getToolFocusOptions = () => {
    axios
      .get(url.getAllFoucsList)
      .then((response) => {
        // console.log(response)
        let { diversityFocusOptions, relevantForOptions } = filterToolFocus(
          response.data
        )

        console.log(relevantForOptions)
        this.setState({
          diversityFocusOptions: diversityFocusOptions.map((x) => ({
            key: x.key,
            category: x.focus,
          })),
          relevantForOptions: relevantForOptions.map((x) => ({
            key: x.key,
            category: x.focus,
          })),
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  handleShareStore = (method, type) => {
    let onModel = 'OfficeToolkit'
    const item = this.state.selectedToolToShare
    let payload = {
      shareMethod: method,
      shareType: type,
      itemId: item._id,
      itemModel: onModel,
    }

    axios
      .post(url.storeShareLogs, payload)
      .then((data) => {
        console.log('stored_shared', data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleSocialShare = (data) => {
    return new Promise((resolve, reject) => {
      const { selectedToolToShare } = this.state
      let finalString = this.getTextFormat(
        { ...selectedToolToShare },
        data.type
      )
      if (data.type === 'SLACK') {
        finalString = finalString
          .replaceAll('<b>', '')
          .replaceAll('</b>', '')
          .replaceAll('<strong>', '')
          .replaceAll('</strong>', '')
      }
      let payload = {
        storyText: finalString,
        attachmentsText: '',
        user: {
          username: data.isAnonymous
            ? 'Anonymous'
            : `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`,
          text: '',
        },
        entityType: 'RESOURCES',
        channelId: data.channelId,
        channelName: data.channelName,
        type: data.type,
        workSpaceId: data.workSpaceId,
        teamId: data.teamId,
        tenantId: data.tenantId,
      }

      axios
        .post(url.shareStoryPost, payload)
        .then(({ data }) => {
          // console.log("data shared----", data);
          resolve(payload.channelId)
          const method = payload.type === 'SLACK' ? 2 : 3
          this.handleShareStore(method, payload.channelName)
          toastContainer('Shared successfully', 'success')
        })
        .catch((error) => {
          let message = 'Error occured while sending message'
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message === 'channel_not_found'
          ) {
            message =
              'Dani is not added as a member to this channel , Please Add Dani as a member to this channel to Post a message'
          }
          toastContainer(message, 'error')
          reject(message)
        })
    })
  }

  getTextFormat = (tool, dataType) => {
    const item = { ...tool }

    const attachmentsArr =
      item.attachments && item.attachments.length ? [...item.attachments] : []

    if (item.image) {
      attachmentsArr.push({ type: { mime: 'Image' }, url: item.image })
    }

    let finalString = `<div>
     <div>
        <ul>
        {{middle_string}}
        </ul>
     </div>
     </div>`

    let middle_string = ''

    if (item.name) {
      const isEvent = tool.category === 'Conferences & Events'
      middle_string += `<li> Name:  ${item.name} ${
        isEvent
          ? `(${moment(tool.startDate).format('MMM D, YYYY')} -  ${moment(
              tool.endDate
            ).format('MMM D, YYYY')})`
          : ''
      } </li>`
    }
    if (item.category) {
      middle_string += `<li> Category:  ${item.category} </li>`
    }
    if (item.subCategory) {
      middle_string += `<li>Sub Category:  ${item.subCategory} </li>`
    }
    if (item.createdBy) {
      middle_string += `<li> Created By:${item.createdBy.firstName || ''}${item
        .createdBy.lastName || ''} </li>`
    }
    if (item.categoryTypes) {
      middle_string += `<li> Diversity:${this.showCategoryTypesStr(
        item,
        '1'
      )} </li>`
    }
    if (item.categoryTypes) {
      middle_string += `<li> Aimed at :${this.showCategoryTypesStr(
        item,
        '2'
      )} </li>`
    }

    if (item.bannerImg && item.bannerImg.url) {
      middle_string += `<li> Banner Image :${item.bannerImg.url} </li>`
    }
    if (item.description && item.description.length) {
      middle_string += `<li> Description :${item.description.slice(3)} </li>`
    }

    if (attachmentsArr.length) {
      if (dataType === 'SLACK') {
        middle_string += `<li> <b> Attachments </b> : <ul> ${attachmentsArr
          .map((x) => {
            if (x.type && x.type.mime && x.url) {
              return `<li>
              Type:${x.type.mime}  ${x.url}
              </li>`
            } else {
              return ''
            }
          })
          .join('')}  </ul></li>`
      } else {
        middle_string += `<li> <b> Attachments </b> : <ul> ${attachmentsArr
          .map((x) => {
            if (x.type && x.type.mime && x.url) {
              const upload = uploadPreview(x)
              if (upload.isMsIcon) {
                return `<li><b> Type : ${x.type.mime} </b>   <a target="_blank" href=${x.url}> ${x.url} </a>  <br></li>`
              } else {
                return `<li><a href=${x.url}> <br><img src=${x.url}></a> </li>`
              }
            } else {
              return ''
            }
          })
          .join('')}  </ul></li>`
      }
    }

    if (item._id && item._id) {
      if (dataType === 'SLACK') {
        middle_string += `<li> Resource Url  :${baseUrl()}home/toolkit/all/tool/${
          item._id
        } </li>`
      } else {
        middle_string += `<li> Resource Url  :<a href=${baseUrl()}home/toolkit/all/tool/${
          item._id
        }> ${baseUrl()}home/toolkit/all/tool/${item._id} </a> </li>`
      }
    }

    finalString = finalString.replace('{{middle_string}}', middle_string)

    return finalString
  }

  createEmailTxt = (tool) => {
    let text = this.getTextFormat(tool)

    text = text
      .replaceAll('<b>', '')
      .replaceAll('</b>', '')
      .replaceAll('<strong>', '')
      .replaceAll('</strong>', '')

    text = new TurndownService().use(gfm).turndown(text)

    return text
  }

  showSelectSlackchannels = (tool) => {
    this.setState({
      showSlackShare: true,
      selectedToolToShare: tool,
      dropdownItmOpen: null,
    })
  }
  showSelectTeamschannels = (tool) => {
    this.setState({
      showTeamsShare: true,
      selectedToolToShare: tool,
      dropdownItmOpen: null,
    })
  }

  sortData = (list) => {
    const { selectedSort } = this.state
    // console.log(selectedSort);
    if (selectedSort === 'a-z') {
      list = sortBy(list, [
        function(tool) {
          return tool.name.toLowerCase()
        },
      ])
    } else if (selectedSort === 'z-a') {
      list = reverse(
        sortBy(list, [
          function(tool) {
            return tool.name.toLowerCase()
          },
        ])
      )
    } else if (selectedSort === 'last-updated') {
      list = reverse(
        sortBy(list, [
          function(tool) {
            return tool.lastUpdate.updatedData.date
          },
        ])
      )
    }
    return list
  }

  filterData = (filters, allTools) => {
    let list = allTools
    const { officeId, _id } = this.props.user.profile
    const userOfficeId =
      officeId && officeId !== undefined && officeId !== null
        ? officeId._id
        : null
    const userId = _id

    if (
      filters['subCategory'] &&
      filters['subCategory'].length > 0 &&
      findIndex(filters['subCategory'], { subCategoryValue: 'All' }) === -1
    ) {
      list = list.filter((tool) => {
        if (
          tool['subCategory'] &&
          find(filters['subCategory'], {
            subCategoryValue: tool['subCategory'],
          })
        ) {
          return true
        }
      })
    }
    if (
      filters['category'] &&
      filters['category'].length > 0 &&
      findIndex(filters['category'], { category: 'All' }) === -1
    ) {
      list = list.filter((tool) => {
        if (
          tool['category'] &&
          find(filters['category'], { category: tool['category'] })
        ) {
          return true
        }
      })
    }

    if (
      filters['createdBy'] &&
      filters['createdBy'].length > 0 &&
      findIndex(filters['createdBy'], { category: 'All' }) === -1
    ) {
      let filteredList = []
      // console.log(filters['createdBy']);
      list.forEach((tool) => {
        // console.log('tool---', tool.createdBy)
        // console.log('usr----', this.props.user.profile._id)

        if (find(filters['createdBy'], { key: 'PRIVATE' })) {
          let toolId =
            tool.createdBy && tool.createdBy.hasOwnProperty('_id')
              ? tool.createdBy._id
              : tool.createdBy
          if (toolId) {
            if (toolId === userId) {
              filteredList.push(tool)
            }
          }
        }

        if (find(filters['createdBy'], { key: 'CUSTOM' })) {
          // console.log('custom: ', tool)
          tool.invitedUsers.filter((e) => {
            if (e.value == userId) {
              filteredList.push(tool)
            }
          })
        }

        if (find(filters['createdBy'], { key: 'ENTERPRISE' })) {
          // console.log('tool: ', tool)
          if (tool.privacy === 'ENTERPRISE') {
            filteredList.push(tool)
          }
        }

        if (find(filters['createdBy'], { key: 'DANI' })) {
          if (tool.isRecommendedByAdmin) {
            filteredList.push(tool)
          }
        }
      })
      // console.log(filteredList);
      filteredList = uniqBy(filteredList, '_id')
      list = deepClone(filteredList)
    }

    if (
      filters['relevantFor'] &&
      filters['relevantFor'].length > 0 &&
      findIndex(filters['relevantFor'], { category: 'All' }) === -1
    ) {
      list = list.filter((tool) => {
        // console.log(tool['categoryTypes']['2']);
        if (
          tool['categoryTypes']['2'] &&
          tool['categoryTypes']['2'].length > 0
        ) {
          let relevantForFields = tool['categoryTypes']['2']
          if (
            find(filters['relevantFor'], (filter) => {
              if (find(relevantForFields, { focus: filter.category })) {
                return true
              }
            })
          ) {
            return true
          }
        }
      })
    }
    if (
      filters['diversityFocus'] &&
      filters['diversityFocus'].length > 0 &&
      findIndex(filters['diversityFocus'], { category: 'All' }) === -1
    ) {
      list = list.filter((tool) => {
        if (find(filters['diversityFocus'], { category: 'Other' })) {
          if (tool.toolkitTags.diversityFocusTags.length > 0) {
            return true
          }
        }
        if (
          tool['categoryTypes']['1'] &&
          tool['categoryTypes']['1'].length > 0
        ) {
          let diversityFocusFields = tool['categoryTypes']['1']
          if (
            find(filters['diversityFocus'], (filter) => {
              if (find(diversityFocusFields, { focus: filter.category })) {
                return true
              }
            })
          ) {
            return true
          }
        }
      })
    }

    if (filters['eventDates'] && filters['eventDates'].length === 2) {
      const value = [...filters.eventDates].map((x) => new Date(x))
      console.log(value)
      const start = moment(value[0]).subtract(1, 'day')
      const end = moment(value[1])

      console.log(start.format('MM/DD/YYYY'), end.format('MM/DD/YYYY'))
      list = list.filter(
        (tool) =>
          moment(tool.startDate).isBetween(start, end) ||
          moment(tool.endDate).isBetween(start, end)
      )
    }
    return list
  }

  applyFilters = (filters, search) => {
    console.log(filters, search)
    const { toolkitCategory } = this.state
    const filterObject = {}

    for (const item in filters) {
      if (Object.hasOwnProperty.call(filters, item)) {
        const ele = filters[item]

        if (item == 'subCategory') {
          if (ele.length) {
            const items = ele.map((x) => x.subCategoryValue)
            filterObject[item] = [...items]
          }
        }

        if (item == 'category') {
          if (ele.length) {
            const items = ele.map((x) => {
              console.log(x)
              const mappedValue = find(toolkitCategories, { name: x.category })

              return mappedValue.name
            })
            filterObject[item] = [...items]
          }
        }
        if (item == 'createdBy') {
          if (ele.length) {
            const items = ele.map((x) => x.key)
            filterObject['privacy'] = [...items]
          }
        }
        if (item == 'diversityFocus') {
          if (ele.length) {
            const items = ele.map((x) => x.key)
            filterObject['diversityFocus'] = [...items]
          }
        }
        if (item == 'relevantFor') {
          if (ele.length) {
            const items = ele.map((x) => x.key)
            filterObject['relevantFor'] = [...items]
          }
        }

        if (item == 'eventDates') {
          if (ele.length != 1) {
            const items = ele.map((x) => new Date(x))
            filterObject['eventDates'] = [...items]
          } else {
            return
          }
        }
        if (item == 'location') {
          filterObject['location'] = ele
        }
        // if (item == "distance") {
        //   if (ele.value === "any") {
        //     return;
        //   }
        //   filterObject["distance"] = ele.value;
        // }
      }
    }

    if (toolkitCategory !== 'all') {
      if (Array.isArray(filterObject.category)) {
        const mappedValue = find(toolkitCategories, { link: toolkitCategory })
        filterObject.category.push(mappedValue.name)
      } else {
        const mappedValue = find(toolkitCategories, { link: toolkitCategory })

        filterObject.category = [mappedValue.name]
      }
    }

    const { category } = this.props.match.params
    const mappedValue = find(toolkitCategories, { link: category })
    // console.log(this.props.dani);

    let categoryName = mappedValue.name

    // console.log(categoryName)
    if (categoryName === 'Programs & Initiatives') {
      categoryName = 'Programs & Initiatives'
    }

    axios
      .post(url.fetchToolkitsByCategoryFilter(categoryName, ''), {
        filters: filterObject,
        search,
      })
      .then(({ data }) => {
        const payload = data
        this.setState({
          displayTools: payload,
          toolCount: payload.length,
          allTools: payload,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleFilterSelected = (selectedFilterOption, filterId) => {
    const {
      filters,
      allTools,
      searchedTerm,
      displayTools,
      sortType,
    } = this.state

    const filterType = find(
      toolkitCategoryFilterMapping,
      (o) => o.key === filterId
    ).type
    let list
    filters[filterType] = selectedFilterOption

    // list = this.filterData(filters, allTools);

    // if (searchedTerm.length > 0) {
    //   list = filter(list, (tool) =>
    //     tool.name.toLowerCase().includes(searchedTerm.toLowerCase())
    //   );
    // }

    // list = this.sortData(list);

    this.setState(
      {
        filters: filters,
      },
      () => {
        this.applyFilters(this.state.filters, this.state.searchedTerm)
      }
    )
  }

  handleSearchQueryChanged = ({ target }) => {
    const { name, value } = target
    const { filters, allTools } = this.state
    // let mod = value.replace(/\s/g, "");
    // let list = [];
    // if (value.length === 0) {
    //   list = allTools;
    // } else {
    //   list = filter(allTools, (tool) =>
    //     tool.name.toLowerCase().includes(value.toLowerCase())
    //   );
    // }
    // list = this.filterData(filters, list);
    // list = this.sortData(list);

    this.setState(
      {
        searchedTerm: value,
      },
      () => {
        this.applyFilters(this.state.filters, this.state.searchedTerm)
      }
    )
  }

  /**
   * handle when user makes a tool selection from the table
   */
  handleRowClick = (selectedTool) => {
    const { selectedTools } = this.state
    const i = findIndex(selectedTools, (tool) => {
      return tool._id === selectedTool._id
    })
    if (i > -1) {
      selectedTools.splice(i, 1)
    } else {
      selectedTools.push(selectedTool)
    }

    this.setState({
      selectedTools: selectedTools,
    })
  }

  check_table_columns = (categoryName) => {
    let columns = [
      { key: 'name', value: 'Name' },
      { key: 'createdBy', value: 'Privacy' },
      // {key:'category',value:'Category'},
      { key: 'subCategory', value: 'Subcategory' },
      { key: 'diversity_focus', value: 'Diversity' },
      { key: 'relevant_for', value: 'Aimed at' },
      { key: 'address', value: 'Address' },
      // {key:'lastUpdate',value:'Updated'}
    ]

    if (
      categoryName == 'Conferences & Events' ||
      categoryName == 'Diversity Calendar'
    ) {
      // columns = [...columns, {key:'eventDate', value:'Event Date'}]
      columns.splice(2, 0, { key: 'eventDate', value: 'Start & End Date' })
    }

    if (categoryName == 'Diversity Calendar') {
      columns = columns.filter((e) => e.key != 'subCategory')
    }

    if (['Favorites', 'All', 'Archive'].indexOf(categoryName) > -1) {
      columns.splice(2, 0, { key: 'category', value: 'Category' })
    }

    this.setState({ columns })
  }

  componentDidMount() {
    this.getToolFocusOptions()
    // console.log(this.props)
    const { category } = this.props.match.params
    const mappedValue = find(toolkitCategories, { link: category })
    const { currentStep } = this.props.dani
    // console.log(this.props.dani);

    this.setState({
      toolkitCategory: category,
    })

    const { organizationId } = this.props.user.profile

    if (checkValidationOfModule(organizationId, organizationId.isToolkit)) {
    } else {
      if (
        checkValidationOfModule(organizationId, organizationId.isGroups) &&
        mappedValue.name != 'Conferences & Events'
      ) {
        this.props.history.push(
          navigate_user_to_module(
            organizationId,
            true,
            this.props.user.profile.orgAdmin
          )
        )
      }
    }

    let categoryName = mappedValue.name

    // console.log(categoryName)
    if (categoryName === 'Programs & Initiatives') {
      categoryName = 'Programs & Initiatives'
    }

    console.log('----', categoryName)

    axios
      .get(url.fetchToolkitsByCategory(categoryName, 'false'))
      .then(({ data }) => {
        let payload = data
        // console.log('data----',data)
        if (mappedValue.name === 'Archive') {
          payload = data.data
        } else if (mappedValue.name === 'Favorites') {
          payload = data.favList
        }
        // payload = reverse(sortBy(payload, [function(tool) { return tool.lastUpdate.updatedData.date; }]));
        let filters = {}
        this.setState({
          displayTools: payload,
          toolCount: payload.length,
          selectedSort: 'last-updated',
          allTools: payload,
          filters: filters,
          searchedTerm: '',
          toolkitCategory: category,
        })
        if (currentStep && currentStep.subcategory) {
          // payload = payload.filter((tool) => tool.subCategory === currentStep.subcategory);
          filters['subCategory'] = [
            {
              subCategoryKey: `${currentStep.subcategory}`,
              subCategoryValue: `${currentStep.subcategory}`,
            },
          ]
          this.handleFilterSelected(filters['subCategory'], '5')
        }
      })
      .catch((error) => {
        console.log('second error ---- ', error)
        //todo show error
      })

    this.check_table_columns(categoryName)
  }

  componentWillReceiveProps(nextProps) {
    // console.log(this.props.match.params);
    this.setState({
      toolkitCategory: nextProps.match.params.category,
    })

    if (nextProps.match.params.category !== this.props.match.params.category) {
      window.scroll(0, 0)
      // console.log(nextProps.match.params.category);
      const mappedValue = find(toolkitCategories, {
        link: nextProps.match.params.category,
      })

      let categoryName = mappedValue.name

      // console.log(categoryName)
      if (categoryName === 'Programs & Initiatives') {
        categoryName = 'Programs & Initiatives'
      }

      this.check_table_columns(categoryName)

      console.log('second ---- ', categoryName)

      axios
        .get(url.fetchToolkitsByCategory(categoryName, 'false'))
        .then(({ data }) => {
          let payload = data

          if (mappedValue.name === 'All') {
            payload = data
          } else {
            if (mappedValue.name === 'Archive') {
              payload = data.data
            } else if (mappedValue.name === 'Favorites') {
              payload = data.favList
            }
            if (payload.length > 0) {
              payload = reverse(
                sortBy(payload, [
                  function(tool) {
                    return tool.lastUpdate.updatedData.date
                  },
                ])
              )
            } else {
              payload = []
            }
          }

          this.setState({
            displayTools: payload,
            allTools: payload,
            toolCount: payload.length,
            filters: {},
            searchedTerm: '',
            selectedSort: 'last-updated',
            isFilterCollapsed: false,
            selectedTools: [],
          })
        })
        .catch((error) => {
          //todo show error
        })
    }
  }

  handleDeselectAll = () => {
    this.setState({
      selectedTools: [],
    })
  }

  handleRemoveFromFavorites = (tool) => {
    const { selectedTools, toolkitCategory, displayTools } = this.state
    // console.log(selectedTools);
    const data = selectedTools.map((tool) => tool._id)
    // console.log(data);
    const payload = { ids: data }
    if (toolkitCategory === 'favorites') {
      axios
        .put(url.removeFromFavorites, payload)
        .then((response) => {
          if (response) {
            const newTools = filter(displayTools, (tool) => {
              if (find(selectedTools, { _id: tool._id })) {
                // console.log("found value..");
                return false
              }
              return true
            })
            this.setState({
              selectedTools: [],
              displayTools: newTools,
            })
          }
        })
        .catch((error) => {})
    } else {
      if (tool.isFavorite) {
        axios
          .post(url.addToFavorites, payload)
          .then((response) => {
            // console.log(response);
            if (response) {
              this.setState({
                selectedTools: [],
              })
            }
          })
          .catch((error) => {})
      } else {
        axios
          .put(url.removeFromFavorites, payload)
          .then((response) => {
            if (response) {
              const newTools = filter(displayTools, (tool) => {
                if (find(selectedTools, { _id: tool._id })) {
                  // console.log("found value..");
                  return false
                }
                return true
              })
              this.setState({
                selectedTools: [],
                displayTools: newTools,
              })
            }
          })
          .catch((error) => {})
      }
    }
  }

  handleClearFilters = () => {
    const { allTools, searchedTerm } = this.state
    // let list = allTools;
    // if (searchedTerm.length > 0) {
    //   list = filter(allTools, (tool) => tool.name.includes(searchedTerm));
    // }
    // list = this.sortData(list);
    const filtersLen = Object.keys(this.state.filters).length
    if (filtersLen) {
      this.applyFilters({}, searchedTerm)
    }
    this.setState({
      filters: {},
    })
  }

  handleSortSelected = (sortType) => {
    // dateSort:1,
    // nameSort:0,
    const { displayTools, nameSort, dateSort } = this.state
    let list = []

    let updateState
    if (sortType === 'Name') {
      if (nameSort == 0) {
        updateState = { nameSort: 1, dateSort: null }
        list = reverse(
          sortBy(displayTools, [
            function(tool) {
              return tool.name.toLowerCase()
            },
          ])
        )
      } else {
        updateState = { nameSort: 0, dateSort: null }
        list = sortBy(displayTools, [
          function(tool) {
            return tool.name.toLowerCase()
          },
        ])
      }
    } else if (sortType === 'Updated') {
      if (dateSort == 0) {
        updateState = { dateSort: 1, nameSort: null }
        list = reverse(
          sortBy(displayTools, [
            function(tool) {
              return tool.lastUpdate.updatedData.date
            },
          ])
        )
      } else {
        updateState = { dateSort: 0, nameSort: null }
        list = sortBy(displayTools, [
          function(tool) {
            return tool.lastUpdate.updatedData.date
          },
        ])
      }
    }
    //  else if(sortType === 'last-updated') {
    //   list = reverse(sortBy(displayTools, [function(tool) { return tool.lastUpdate.updatedData.date; }]));
    // }
    // console.log(sortType);
    // if(sortType === 'a-z') {
    //   list = sortBy(displayTools, [function(tool) { return tool.name.toLowerCase(); }]);
    // } else if(sortType === 'z-a') {
    //   list = reverse(sortBy(displayTools, [function(tool) { return tool.name.toLowerCase(); }]));
    // } else if(sortType === 'last-updated') {
    //   list = reverse(sortBy(displayTools, [function(tool) { return tool.lastUpdate.updatedData.date; }]));
    // }
    updateState = {
      ...updateState,
      displayTools: list,
      selectedSort: sortType,
    }
    this.setState(updateState)
  }

  populateFilters = () => {
    const { toolkitCategory } = this.state
    return filtersData.map((filter, i) => {
      if (filter._id !== '6' && filter.id != '9') {
        return (
          <div key={filter._id} className="col-lg-6 col-md-6 col-sm-9 mt30">
            <div
              className="text-bolder"
              style={{
                fontSize: '20px',
                marginBottom: '10px',
                lineHeight: '27px',
                color: '#54555A',
              }}>
              {getDisplayByKey(filter._id)}
            </div>
            {console.log(this.state.relevantForOptions)}
            <Select
              name="filter-select"
              placeholder={'Select'}
              value={this.state.filters[getTypeByKey(filter._id)]}
              multi
              onChange={(value) => this.handleFilterSelected(value, filter._id)}
              options={
                filter._id == '1'
                  ? this.state.diversityFocusOptions
                  : this.state.relevantForOptions
              }
              valueKey="key"
              labelKey="category"
              getOptionLabel={({ category }) => category}
              getOptionValue={({ key }) => key}
            />
          </div>
        )
      } else {
        if (toolkitCategory === 'conferences-events') {
          return (
            <div key={filter._id} className="col-lg-6 col-md-6 col-sm-9 mt30">
              <div
                className="text-bolder"
                style={{
                  fontSize: '20px',
                  marginBottom: '10px',
                  lineHeight: '27px',
                  color: '#54555A',
                }}>
                {getDisplayByKey(filter._id)}

                {this.state.filters[getTypeByKey(filter._id)] &&
                this.state.filters[getTypeByKey(filter._id)].length == 2 ? (
                  <span
                    style={{ fontSize: '12px' }}
                    className="text-danger float-right cursor-pointer ml-5"
                    onClick={() => {
                      this.handleFilterSelected([], filter._id)
                    }}>
                    Clear dates
                  </span>
                ) : (
                  ''
                )}
              </div>

              <DatePickerMulti
                value={this.state.filters[getTypeByKey(filter._id)]}
                onChange={(value) =>
                  this.handleFilterSelected(value, filter._id)
                }
                range
                placeholder="Select date range"
                inputClass="event-date-range-filter"
                containerClassName="event-date-range-filter-container"
              />
            </div>
          )
        } else {
          return ''
        }
      }
    })
  }

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state
    this.setState({
      isFilterCollapsed: !isFilterCollapsed,
    })
  }

  handleToolClick = (tool) => {
    const { currentStep } = this.props.dani
    const { toolkitCategory } = this.state

    if (isEmpty(currentStep)) {
      // Binding Event if Naviation flow is Toolkit > Category
      // socketConnection.track("Tool_Click", {
      //   toolCount : 1,
      //   isRecommended : tool.isRecommendedByAdmin,
      //   toolName : tool.name
      // });
    } else {
      // Binding Event if Naviation flow is Dani > Toolkit > Category
      // socketConnection.track("Dani_Tool_Click", {
      //   kpiName : get(this.props.history.location, 'state.selectedKPIName', ''),
      //   toolkitCategoryName : get(tool, 'category', ''),
      //   toolkitName : get(tool, 'name', ''),
      //   toolSubCategoryName : get(tool, 'subCategory', ''),
      //   isRecommended : get(tool, 'isRecommendedByAdmin', '')
      //   // ratingScore : size(tool.ratings)
      // });
    }

    if (currentStep.subcategory) {
      this.props.onToolkitSelected()
    }
    this.setState({ searchedTerm: '' })
    console.log('toolkitCAtegory ---- ', toolkitCategory)
    // Passing Dani Props to ToolDetails to identify Dani Navigation
    this.props.history.push({
      pathname: `/home/toolkit/${toolkitCategory}/tool/${tool._id}`,
      dani: this.props.dani,
    })
  }

  handleAddTool = () => {
    const { toolkitCategory } = this.state
    // console.log(toolkitCategories)
    let result = { groupEvent: null }
    this.props.onProfileUpdate(result)

    const mappedCategory = find(toolkitCategories, { link: toolkitCategory })

    let newToolDetails = {}
    newToolDetails.nextStep = addToolStep.info
    newToolDetails.category = mappedCategory.name
    newToolDetails.currentStep = 1
    newToolDetails.relevantFor = []
    newToolDetails.diversityFocus = []
    this.props.onChooseCategory({
      ...deepClone(initialToolDetailsState),
      ...newToolDetails,
    })

    if (
      toolkitCategory !== 'favorites' &&
      toolkitCategory !== 'archive' &&
      toolkitCategory !== 'all'
    ) {
      // const mappedCategory = find(toolkitCategories,{link : toolkitCategory});
      // console.log(mappedCategory)
      this.props.history.push({
        pathname: `/home/toolkit/${toolkitCategory}/add`,
        state: {
          category: mappedCategory.name,
        },
      })
    } else {
      this.props.history.push('/home/toolkit/choose-category')
    }
  }

  handleArchiveTool = () => {
    const { selectedTools, displayTools, toolkitCategory } = this.state
    const { profile } = this.props.user
    // console.log(selectedTools);
    const ids = selectedTools.map((t) => t._id)
    if (toolkitCategory === 'archive') {
      axios.put(url.restoreTool, { list: ids }).then(({ data }) => {
        const updatedTools = displayTools.filter((t) => {
          if (ids.indexOf(t._id) === -1 || t.isRecommendedByAdmin) {
            return true
          }
        })
        // console.log(updatedTools);
        this.setState({
          displayTools: updatedTools,
          selectedTools: [],
        })
      })
    } else {
      axios.put(url.archiveTools, { ids: ids }).then(({ data }) => {
        const updatedTools = displayTools.filter((t) => {
          if (
            ids.indexOf(t._id) > -1 &&
            !t.isRecommendedByAdmin &&
            (profile.role == UserRole.admin || profile._id === t.createdBy._id)
          ) {
            return false
          }
          return true
        })
        // console.log(updatedTools);
        this.setState({
          displayTools: updatedTools,
          selectedTools: [],
        })
      })
    }
  }

  toggleDefinitionPopover = () =>
    this.setState({
      categoryDefinitionPopoverOpen: !this.state.categoryDefinitionPopoverOpen,
    })

  addGroupModal = (tool) => {
    // let{isGroupModal}=this.state
    // console.log('tool---',tool)
    // console.log('tool---',this.state.isGroupModal)
    this.setState((prevState) => ({
      isGroupModal: !prevState.isGroupModal,
      selectedResource: tool,
    }))
  }

  showToolDate = (tool, column) => {
    if (!tool.isRecommendedByAdmin) {
      return moment(tool[column]['updatedData'].date).format('MM/DD/YYYY')
    } else {
      return ''
    }
  }

  // showToolDate=(tool, column)=>{
  //   if(!tool.isRecommendedByAdmin){
  //     return moment(tool[column]['updatedData'].date ).format("MM/DD/YYYY")
  //   } else {
  //     return ''
  //   }

  // }

  toggle = (tool) => {
    const { dropdownOpen, dropdownItmOpen } = this.state

    if (dropdownItmOpen == null || dropdownItmOpen != tool._id) {
      this.setState({ dropdownItmOpen: tool._id })
    }

    if (dropdownItmOpen == tool._id) {
      this.setState({ dropdownItmOpen: null })
    }
    // this.setState({dropdownOpen : !dropdownOpen});
  }

  ownerFullName = (tool) => {
    let res = ''
    if (tool.createdBy && !tool.isRecommendedByAdmin) {
      let { firstName, lastName } = tool.createdBy
      if (firstName && firstName != null && firstName != '') {
        res = ` ${firstName}`
      }
      if (lastName && lastName != null && lastName != '') {
        res = `${res} ${lastName}`
      }
    }
    return res
  }

  showCategoryTypes = (tool, focus) => {
    let cat = tool['categoryTypes'][focus]
    if (cat && cat.length > 0) {
      let length = cat.length
      if (cat.length == 1) {
        return cat[0].focus
      } else {
        return cat.map((e, idx) => (
          <div key={idx}>
            {idx != length - 1 ? `${e.focus},` : `${e.focus}`}
          </div>
        ))
      }
    } else {
      return 'none'
    }
  }

  showCategoryTypesStr = (tool, focus) => {
    let cat = tool['categoryTypes'][focus]
    if (cat && cat.length > 0) {
      let length = cat.length
      if (cat.length == 1) {
        return cat[0].focus
      } else {
        return cat
          .map((e, idx) => {
            return idx != length - 1 ? `${e.focus},` : `${e.focus}`
          })
          .join('')
      }
    } else {
      return 'none'
    }
  }

  selectMenu = (option) => {
    // const {category} = this.props.match.params;
    // const mappedValue = find(toolkitCategories,{link : category});
    let categoryName = 'Conferences & Events'

    axios
      .get(url.fetchToolkitsByCategory(categoryName, option))
      .then(({ data }) => {
        let payload = data
        let filters = {}
        this.setState({
          displayTools: payload,
          toolCount: payload.length,
          menu: option,
          // selectedSort : "last-updated",
          allTools: payload,
          filters: filters,
          searchedTerm: '',
          // toolkitCategory : category
        })
        // if(currentStep && currentStep.subcategory) {
        //   // payload = payload.filter((tool) => tool.subCategory === currentStep.subcategory);
        //   filters['subCategory'] = [{subCategoryKey: `${currentStep.subcategory}`,
        //   subCategoryValue: `${currentStep.subcategory}`}];
        //   this.handleFilterSelected(filters['subCategory'],"5");
        // }
      })
      .catch((error) => {
        //todo show error
      })
  }

  changeSortField = (key, order) => {
    this.setState(
      {
        sortParams: {
          sortBy: key,
          sortOrder: order,
        },
      },
      () => {
        this.handleSortChange()
      }
    )
  }

  sortComponent = (key) => {
    const { sortParams } = this.state
    // console.log('key --- ', key)
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(key) &&
      sortParams.sortOrder === 'asc'
    ) {
      return (
        <BiDownArrowAlt
          size={'18px'}
          onClick={() => this.changeSortField(key, 'desc')}
        />
      )
    } else {
      return (
        <BiUpArrowAlt
          size={'18px'}
          onClick={() => this.changeSortField(key, 'asc')}
        />
      )
    }
  }

  handleSortChange = () => {
    const { sortBy, sortOrder } = this.state.sortParams
    const key = sortBy
    const order = sortOrder
    console.log(sortBy, sortOrder)
    let tools = [...this.state.displayTools]
    switch (key) {
      case 'name':
        // const startByNumber = tools.filter(
        //   (x) => !isNaN(parseInt(x.name.trim()[0]))
        // );
        // let others = tools.filter((x) => isNaN(parseInt(x.name.trim()[0])));
        tools = orderBy(tools, (tool) => tool.name.trim().toLowerCase(), [
          order,
        ])
        // tools = [...others, ...startByNumber];
        break
      case 'createdBy':
        tools = orderBy(
          tools,
          (tool) =>
            privacyLabel[tool.privacy ? tool.privacy : 'isRecommendedByAdmin'],
          [order]
        )
        break
      case 'category':
        tools = orderBy(tools, (tool) => tool.category.toLowerCase(), [order])
        break
      case 'subCategory':
        tools = orderBy(
          tools,
          (tool) => {
            const subCat = tool.subCategory ? tool.subCategory : 'none'
            return subCat.toLowerCase()
          },
          [order]
        )
        break
      case 'subCategory':
        tools = orderBy(
          tools,
          (tool) => {
            const subCat = tool.subCategory ? tool.subCategory : 'none'
            return subCat.toLowerCase()
          },
          [order]
        )
        break
      case 'diversity_focus':
        tools = orderBy(
          tools,
          (tool) => {
            return this.showCategoryTypesStr(tool, '1')
          },
          [order]
        )
        break
      case 'relevant_for':
        tools = orderBy(
          tools,
          (tool) => {
            return this.showCategoryTypesStr(tool, '2')
          },
          [order]
        )
        break
      case 'address':
        let validAdress = tools.filter((x) => x.eventAddress)
        let blanks = tools.filter((x) => !x.eventAddress)
        validAdress = orderBy(
          validAdress,
          (tool) => {
            return tool.eventAddress.toLowerCase()
          },
          [order]
        )
        tools = [...validAdress, ...blanks]
        break
      case 'startDate':
        tools = orderBy(
          tools,
          (tool) => {
            return moment(tool.startDate)
          },
          [order]
        )
        break
      case 'endDate':
        tools = orderBy(
          tools,
          (tool) => {
            return moment(tool.endDate)
          },
          [order]
        )
        break
    }
    this.setState({ displayTools: [...tools] })
  }

  render() {
    const {
      filters,
      selectedTools,
      searchedTerm,
      dropdownItmOpen,
      menu,
      columns,
      dateSort,
      nameSort,
      isGroupModal,
      selectedResource,
      displayTools,
      isFilterCollapsed,
      toolkitCategory,
      dropdownOpen,
      showSlackShare,
      showTeamsShare,
    } = this.state

    const { profile } = this.props.user
    const hasNoFilters =
      getAppliedFiltersCount(filters) === 0 && searchedTerm.length === 0
    const mappedCategory = find(toolkitCategories, { link: toolkitCategory })

    let categoryName = ''
    let categoryDefinition = ''
    let subCategoryOptions =
      mappedCategory && mappedCategory.name
        ? getSubcategories(mappedCategory.name)
        : []

    //  = toolkitCategory ==='all' || toolkitCategory ==='favorites' || toolkitCategory === 'archive' ? this.favoriteColumns : this.columns;
    let canArchiveSelectedTools = false
    selectedTools.forEach((t) => {
      if (
        !t.isRecommendedByAdmin &&
        profile.role == UserRole.admin &&
        profile._id === t.createdBy._id
      ) {
        canArchiveSelectedTools = true
      }
    })

    const teamsEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedTeamsTenants
        ? this.props.user.profile.organizationId.allowedTeamsTenants.length > 0
        : false
    const slackEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedSlackWorkspaces
        ? this.props.user.profile.organizationId.allowedSlackWorkspaces.length >
          0
        : false

    // console.log('displayTools---', displayTools)
    return (
      <div className="toolkitPageContainer">
        <div className="ml-1 mb-3 ml-3 text-size">
          <div className="title-text">
            {/* Toolkit:  */}
            {mappedCategory ? mappedCategory.name : null}
            <span style={{ marginLeft: '6px' }}>({this.state.toolCount})</span>
            {categoryDefinition && (
              <span>
                <span
                  className="ml10"
                  id="category-definition-popover"
                  onClick={this.toggleDefinitionPopover}>
                  <Tooltip />
                </span>
                <Popover
                  placement="right"
                  isOpen={this.state.categoryDefinitionPopoverOpen}
                  target="category-definition-popover"
                  toggle={this.toggleDefinitionPopover}>
                  <PopoverHeader className="popover-header-tooltip">
                    {categoryName}
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    {categoryDefinition}
                  </PopoverBody>
                </Popover>
              </span>
            )}
          </div>
          <div
            className="addToolBtnContainer"
            style={{ marginBottom: '.5rem' }}>
            <Button
              color="primary"
              className="add-tool align-right add-tool-btn"
              // onClick={() => {this.props.history.push('choose-category')}}
              onClick={this.handleAddTool}>
              <span className="flaticon-plus" /> Create{' '}
              {toolkitCategory == 'conferences-events'
                ? 'an event'
                : 'a resource'}
            </Button>
          </div>
        </div>

        {toolkitCategory == 'conferences-events' ? (
          <div className="profile-user-page">
            <ul className="data-user">
              <li>
                <a
                  className={`${
                    menu == 0 ? 'profile_page_menu_option_active' : ''
                  }`}
                  onClick={() => this.selectMenu(0)}>
                  Current Events
                </a>
              </li>

              <li>
                <a
                  className={`${
                    menu == 1 ? 'profile_page_menu_option_active' : ''
                  }`}
                  onClick={() => this.selectMenu(1)}>
                  Past Events
                </a>
              </li>
            </ul>
          </div>
        ) : null}

        {displayTools.length === 0 &&
        hasNoFilters &&
        toolkitCategory === 'favorites' ? (
          <div className="text-center">
            <img
              style={{ width: '371px', height: '266px' }}
              src={placeholder}
            />
            <div
              style={{
                marginTop: '40px',
                marginBottom: '25px',
                color: '#54555F',
                fontSize: '24px',
                lineHeight: '46px',
                fontWeight: '600 ',
              }}>
              You haven’t added any Favorites yet
            </div>
            <div
              style={{
                color: '#54555F',
                fontSize: '20px',
                lineHeight: '33px',
                marginBottom: '40px',
              }}>
              Favorites let you personalize your Toolkit. Here you can access
              resources and solutions that you find most useful, are actively
              working on, or may want to refer to frequently. As you browse and
              find tools in the Toolkit or create new tools, you can add them to
              your Favorites.
            </div>
          </div>
        ) : displayTools.length === 0 &&
          hasNoFilters &&
          toolkitCategory === 'archive' ? (
          <div className="text-center">
            <img
              style={{ width: '371px', height: '266px' }}
              src={placeholder}
            />
            <div
              style={{
                marginTop: '40px',
                marginBottom: '25px',
                color: '#54555F',
                fontSize: '24px',
                lineHeight: '46px',
                fontWeight: '600 ',
              }}>
              You haven’t archived any tools yet.
            </div>
            <div
              style={{
                color: '#54555F',
                fontSize: '20px',
                lineHeight: '33px',
                marginBottom: '40px',
              }}>
              Once you archive a tool, it will appear here.
            </div>
          </div>
        ) : (
          <div>
            {selectedTools.length > 0 ? (
              <div className="row p-0 m-0" style={{ height: '40px' }}>
                <div className="col-lg-3 col-md-12 col-sm-12 selected-tool-actions mb-2">
                  {toolkitCategory === 'favorites' ? (
                    <span>{selectedTools.length} favorites selected </span>
                  ) : (
                    <span>{selectedTools.length} tools selected</span>
                  )}
                </div>
                <div className="row col-lg-9 col-md-12 col-sm-12 pr0"></div>
              </div>
            ) : (
              <div>
                {displayTools.length >= 0 ? (
                  <span>
                    <div className="row p-0 m-0" style={{ height: '40px' }}>
                      <div className="col-lg-10 col-md-12 col-sm-12 mb-2">
                        <InputGroup style={{ height: '40px' }}>
                          <Input
                            className="toolkit-field tool-search-box"
                            placeholder="Search by tool name"
                            onChange={this.handleSearchQueryChanged}
                            value={searchedTerm}
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              className="color-DADADA border-color-C3C4C7"
                              style={{
                                height: '40px',
                                backgroundColor: 'white !important',
                              }}>
                              <i
                                style={{ color: '#818389' }}
                                className="flaticon-search"></i>
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </div>
                      <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr10">
                        <Button
                          color={'secondary-filled'}
                          onClick={this.toggleCollapse}
                          style={{
                            marginBottom: '1rem',
                            width: '100%',
                            height: '40px',
                          }}>
                          <span className="tool-list-font">
                            <i
                              className="flaticon-equalizer"
                              style={{
                                fontSize: '18px',
                                marginRight: '8px',
                                color: '#3B3C41',
                              }}></i>
                            Filters
                          </span>
                          {getAppliedFiltersCount(filters) > 0 ? (
                            <span style={{ marginLeft: '4px' }}>
                              ({getAppliedFiltersCount(filters)})
                            </span>
                          ) : null}
                        </Button>
                      </div>
                    </div>

                    <div className="row p-0 m-0">
                      <Collapse
                        isOpen={isFilterCollapsed}
                        className="col-lg-12 col-sm-12 col-md-12"
                        toggler="#toggler"
                        style={{ width: '100%' }}>
                        <div>
                          <div>
                            <div className="row">
                              {toolkitCategory === 'all' ||
                              toolkitCategory === 'favorites' ||
                              toolkitCategory === 'archive' ? (
                                <div className="col-lg-6 col-md-6 col-sm-9 mt30">
                                  <div
                                    className="text-bolder"
                                    style={{
                                      fontSize: '20px',
                                      marginBottom: '10px',
                                      lineHeight: '27px',
                                      color: '#54555A',
                                    }}>
                                    Category
                                  </div>
                                  <Select
                                    name="filter-select"
                                    placeholder={'Select'}
                                    value={
                                      this.state.filters[getTypeByKey('4')]
                                    }
                                    multi
                                    onChange={(value) =>
                                      this.handleFilterSelected(value, '4')
                                    }
                                    options={toolkitCategoryFilterValues}
                                    valueKey="key"
                                    labelKey="category"
                                    getOptionLabel={({ category }) => category}
                                    getOptionValue={({ key }) => key}
                                  />
                                </div>
                              ) : (
                                <div className="col-lg-6 col-md-6 col-sm-9 mt30">
                                  <div
                                    className="text-bolder"
                                    style={{
                                      fontSize: '20px',
                                      marginBottom: '10px',
                                      lineHeight: '27px',
                                      color: '#54555A',
                                    }}>
                                    Subcategory
                                  </div>
                                  <Select
                                    name="filter-select"
                                    disabled={subCategoryOptions.length === 1}
                                    placeholder={'Select'}
                                    value={
                                      subCategoryOptions.length === 1
                                        ? {
                                            subCategoryKey: 'n/a',
                                            subCategoryValue: 'n/a',
                                          }
                                        : this.state.filters[getTypeByKey('5')]
                                    }
                                    multi
                                    onChange={(value) =>
                                      this.handleFilterSelected(value, '5')
                                    }
                                    options={subCategoryOptions}
                                    valueKey="subCategoryKey"
                                    labelKey="subCategoryValue"
                                    getOptionLabel={({ subCategoryValue }) =>
                                      subCategoryValue
                                    }
                                    getOptionValue={({ subCategoryKey }) =>
                                      subCategoryKey
                                    }
                                  />
                                </div>
                              )}
                              <div className="col-lg-6 col-md-6 col-sm-9 mt30">
                                <div
                                  className="text-bolder"
                                  style={{
                                    fontSize: '20px',
                                    marginBottom: '10px',
                                    lineHeight: '27px',
                                    color: '#54555A',
                                  }}>
                                  Privacy
                                </div>
                                <Select
                                  name="filter-select"
                                  placeholder={'Select'}
                                  value={this.state.filters[getTypeByKey('3')]}
                                  multi
                                  onChange={(value) =>
                                    this.handleFilterSelected(value, '3')
                                  }
                                  options={[
                                    { key: 'all', category: 'All' },
                                    { key: 'PRIVATE', category: 'Private' },
                                    // {key : 'OFFICE',category:'Me and My Office'},
                                    // {key : 'OFFICE_AND_CHILDREN',category:'Offices Above Me'},
                                    { key: 'ENTERPRISE', category: 'Everyone' },
                                    {
                                      key: 'CUSTOM',
                                      category: 'Shared with specific people',
                                    },
                                    { key: 'DANI', category: 'Recommended' },
                                  ]}
                                  valueKey="key"
                                  labelKey="category"
                                  getOptionLabel={({ category }) => category}
                                  getOptionValue={({ key }) => key}
                                />
                              </div>
                              {this.populateFilters()}

                              <div className="col-lg-6 col-md-6 col-sm-9 mt30">
                                <div
                                  className="text-bolder"
                                  style={{
                                    fontSize: '20px',
                                    marginBottom: '10px',
                                    lineHeight: '27px',
                                    color: '#54555A',
                                  }}>
                                  Location
                                  {this.state.address &&
                                  this.state.filters['location'] &&
                                  this.state.filters['location'].coordinates ? (
                                    <span
                                      style={{ fontSize: '12px' }}
                                      className="text-danger float-right cursor-pointer ml-5"
                                      onClick={() => {
                                        this.setState({ address: '' })
                                        this.handleFilterSelected(
                                          {
                                            bounding: [],
                                            coordinates: [],
                                            distance: null,
                                          },
                                          '7'
                                        )
                                      }}>
                                      Clear Location
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </div>
                                <div
                                  style={{ display: 'flex' }}
                                  className="locationDistanceAlign">
                                  <AutocompleteAddress
                                    address={this.state.address}
                                    diffrentiateSearch
                                    handleSelectBounding={(
                                      address,
                                      boundingBox,
                                      coordinates
                                    ) => {
                                      this.setState({
                                        address: address,
                                      })
                                      this.handleFilterSelected(
                                        {
                                          ...this.state.filters.location,
                                          bounding: boundingBox,
                                          coordinates: coordinates,
                                        },
                                        '7'
                                      )
                                    }}

                                    // customClassName={
                                    //   this.state.filters["location"] &&
                                    //   "search-input-length-shrink"
                                    // }
                                  />

                                  {this.state.filters['location'] &&
                                    this.state.filters['location']
                                      .coordinates &&
                                    this.state.filters['location'].coordinates
                                      .length === 2 && (
                                      <Select
                                        name="filter-select"
                                        placeholder={'Select distance within'}
                                        value={
                                          this.state.filters.location
                                            .distance || 'any'
                                        }
                                        onChange={(value) =>
                                          this.handleFilterSelected(
                                            {
                                              ...this.state.filters.location,
                                              distance: value.value,
                                            },
                                            '7'
                                          )
                                        }
                                        options={MAX_DISTANCE_OPTIONS}
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                marginTop: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '18px',
                                lineHeight: '25px',
                              }}>
                              <Button
                                color="secondary-filled"
                                onClick={this.toggleCollapse}>
                                <span
                                  style={{
                                    fontSize: '18px',
                                    lineHeight: '25px',
                                  }}>
                                  Close Filter
                                </span>
                              </Button>
                              <span
                                style={{
                                  marginLeft: '20px',
                                  color: '#1679C4',
                                  fontSize: '18px',
                                  cursor: 'pointer',
                                  lineHeight: '25px',
                                }}
                                onClick={this.handleClearFilters}>
                                Clear Filters
                              </span>
                            </div>
                            <hr
                              style={{ marginTop: '30px', marginBottom: '0px' }}
                            />
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </span>
                ) : null}

                {this.state.searchedTerm.length > 0 &&
                displayTools.length > 0 ? (
                  displayTools.length === 1 ? (
                    <p className="toolFilterResults">
                      {displayTools.length + ' result found'}
                    </p>
                  ) : (
                    <p className="toolFilterResults">
                      {displayTools.length + ' results found'}
                    </p>
                  )
                ) : null}
              </div>
            )}

            <div className="row p-1 m-1 mt-3 toolkitCategoryTable">
              <Table
                responsive
                hover
                className="toolkit-list-table text-primary-color tool-list-font">
                <thead>
                  <tr className="font-weight-bold text-secondary">
                    <th
                      width="5%"
                      scope="col"
                      className="bottom-border-color toolkitTableTh"
                      style={whiteLabelStyling(
                        ['borderBottomColor'],
                        this.props.user.profile.organizationId
                      )}></th>

                    {columns.map((column) => {
                      return (
                        <th
                          key={column.key}
                          width={column.width ? column.width : 'auto'}
                          scope="col"
                          // onClick={
                          //   column.value == "Updated" || column.value == "Name"
                          //     ? () => this.handleSortSelected(column.value)
                          //     : null
                          // }
                          style={whiteLabelStyling(
                            ['borderBottomColor', ''],
                            this.props.user.profile.organizationId
                          )}
                          // style={{borderTop:'none',width: '25%',textAlign : column.key === 'lastUpdate' ? 'right' : 'initial'}}
                          className="bottom-border-color toolkitTableTh">
                          {column.value}

                          {column.key == 'eventDate' ? (
                            <div>
                              Start {this.sortComponent('startDate')}{' '}
                              <span className="ml-1">
                                {' '}
                                End {this.sortComponent('endDate')}{' '}
                              </span>
                            </div>
                          ) : (
                            this.sortComponent(column.key)
                          )}
                          {/* {column.value === "Name"
                            ? nameSort == 0
                              ? " ↑"
                              : nameSort == 1
                              ? " ↓"
                              : " ↑↓"
                            : null}
                          {column.value === "Updated"
                            ? dateSort == 0
                              ? " ↑"
                              : dateSort == 1
                              ? " ↓"
                              : " ↑↓"
                            : null} */}
                        </th>
                      )
                    })}
                  </tr>
                </thead>

                <tbody>
                  {displayTools.length > 0 ? (
                    displayTools.map((tool, i) => {
                      return (
                        <tr
                          key={i}
                          className=""
                          // onClick={() => this.handleToolClick(tool)}
                        >
                          <td className="text-center">
                            <Dropdown
                              className="table_tk_td_dd_container"
                              isOpen={dropdownItmOpen == tool._id}
                              toggle={() => this.toggle(tool)}
                              style={{ float: 'right' }}>
                              <DropdownToggle
                                tag="span"
                                className="chart-item-menu"
                                onClick={() => this.toggle(tool)}
                                data-toggle="dropdown"
                                aria-expanded={dropdownItmOpen == tool._id}>
                                <i
                                  className="chart-item-menu flaticon-menu-1"
                                  style={{ cursor: 'pointer' }}></i>
                              </DropdownToggle>

                              <DropdownMenu
                                className="chart-dropdown"
                                style={{ padding: '0' }}>
                                <div
                                  className="chart-list-dropdown-options"
                                  onClick={() => this.handleToolClick(tool)}>
                                  <i className="ml-1 chart-item-menu flaticon-vision mr-2" />
                                  <span className="chart-list-dropdown-options-text">
                                    View
                                  </span>
                                </div>

                                {/* <div className="chart-list-dropdown-options"
                   onClick={()=>this.handleRemoveFromFavorites(tool)} >
                       {tool.isFavorite?
                        <img style={{height:'20px',marginBottom:'18px',marginLeft:'12px'}} src={favoritedIcon}/>
                      :
                      <i className="chart-item-menu flaticon-heart"></i>
                      }

                    <span className="chart-list-dropdown-options-text">
                          <span className="">
                          {
                            toolkitCategory === 'favorites' ? 'Remove from Favorites' : 'Add to Favorites'
                          }
                          </span>
                    </span>
                </div> */}

                                {canAddToGroup(
                                  tool,
                                  this.props.user.profile
                                ) ? (
                                  <div
                                    className="chart-list-dropdown-options"
                                    onClick={() => this.addGroupModal(tool)}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      viewBox="0 0 16 16"
                                      className="mr-2">
                                      <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
                                    </svg>

                                    {/* <img src={communityIcon} className="chart_list_group_icon"/> */}
                                    <span className="chart-list-dropdown-options-text">
                                      Add to Group
                                    </span>
                                  </div>
                                ) : null}

                                {/* <div className="chart-list-dropdown-options"
                  style={{ display:canArchiveChart ? 'flex' : 'none' }}
                  onClick={this.handleArchive}>
                    <i className={category === 'archive' || isArchived ?
                      "chart-item-menu flaticon-update" : "chart-item-menu flaticon-trash"}></i>
                    <span className="chart-list-dropdown-options-text">
                      {
                        category === 'archive' || isArchived ? `Restore` : `Archive`
                      }
                    </span>
                </div> */}

                                <div
                                  className={
                                    slackEnabled
                                      ? 'chart-list-dropdown-options'
                                      : 'chart-list-dropdown-options-disable'
                                  }
                                  onClick={() =>
                                    slackEnabled
                                      ? this.showSelectSlackchannels(tool)
                                      : null
                                  }>
                                  <BiLogoSlack size={19} />
                                  <span
                                    className={
                                      slackEnabled
                                        ? 'chart-list-dropdown-options-text'
                                        : 'chart-list-dropdown-options-text-disable'
                                    }>
                                    {' '}
                                    {slackEnabled
                                      ? 'Share To Slack'
                                      : 'Slack not enabled'}
                                  </span>
                                </div>

                                <div
                                  className={
                                    teamsEnabled
                                      ? 'chart-list-dropdown-options'
                                      : 'chart-list-dropdown-options-disable'
                                  }
                                  onClick={() =>
                                    teamsEnabled
                                      ? this.showSelectTeamschannels(tool)
                                      : null
                                  }>
                                  <BiLogoMicrosoftTeams size={19} />
                                  <span
                                    className={
                                      teamsEnabled
                                        ? 'chart-list-dropdown-options-text'
                                        : 'chart-list-dropdown-options-text-disable'
                                    }>
                                    {' '}
                                    {teamsEnabled
                                      ? 'Share To Teams'
                                      : 'Teams not enabled'}
                                  </span>
                                </div>
                                <div
                                  className="chart-list-dropdown-options"
                                  onClick={() => {
                                    this.handleShareStore(1, 'NORMAL_EMAIL')
                                    window.open(
                                      `mailto:someone@yoursite.com?subject=${'Resource Share'}&body=${encodeURIComponent(
                                        this.createEmailTxt(tool)
                                      )}`
                                    )
                                  }}>
                                  <BiMailSend size={'18px'} />{' '}
                                  <span className="chart-list-dropdown-options-text">
                                    {' '}
                                    Share To Email
                                  </span>
                                </div>
                                <div
                                  className="chart-list-dropdown-options"
                                  onClick={() => {
                                    this.handleShareStore(1, 'GMAIL')
                                    window.open(
                                      `https://mail.google.com/mail/u/0/?fs=1&to=&su=${'Resource Share'}&body=${encodeURIComponent(
                                        this.createEmailTxt(tool)
                                      )}&tf=cm`
                                    )
                                  }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="19"
                                    fill="currentColor"
                                    viewBox="0 0 16 22"
                                    className="">
                                    <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
                                  </svg>{' '}
                                  <span className="chart-list-dropdown-options-text">
                                    Share Via Gmail
                                  </span>
                                </div>

                                <div
                                  className="chart-list-dropdown-options"
                                  onClick={() => {
                                    this.handleShareStore(0, 'COPY')
                                    navigator.clipboard.writeText(
                                      this.createEmailTxt(tool)
                                    )
                                    toastContainer(
                                      'Copied successfully',
                                      'success'
                                    )
                                  }}>
                                  <BiCopy
                                    className="mr-1"
                                    size={'18px'}
                                    color="white"
                                  />
                                  <span className="chart-list-dropdown-options-text">
                                    {' '}
                                    Copy
                                  </span>
                                </div>
                              </DropdownMenu>
                            </Dropdown>

                            {/* <Checkbox
                              checked={findIndex(selectedTools,
                                (selectedTool) => {return tool._id === selectedTool._id}) > -1}
                              type="checkbox"
                              onClick={() => this.handleRowClick(tool)}></Checkbox> */}
                          </td>
                          <td>
                            {tool.name}

                            <span className="toolkit_page_table_created">
                              <span
                                className="toolkit_view_tool_btn"
                                onClick={() => this.handleToolClick(tool)}>
                                (view)
                              </span>

                              {!tool.isRecommendedByAdmin ? (
                                <span className="resource_author_dv">
                                  by {this.ownerFullName(tool)}{' '}
                                  <span className="user_gender_pronoun_toolslist">
                                    {' '}
                                    {renderGenderPronoun(tool.createdBy)}{' '}
                                  </span>{' '}
                                </span>
                              ) : null}
                            </span>
                            {/* <span className="linkedToolView" onClick={()=>this.viewTool(tool)}>(view)</span> */}
                          </td>
                          <td>
                            {
                              privacyLabel[
                                tool.privacy
                                  ? tool.privacy
                                  : 'isRecommendedByAdmin'
                              ]
                            }
                            {/* {tool.createdBy.firstName} {tool.createdBy.lastName?tool.createdBy.lastName:''}  */}
                          </td>

                          {toolkitCategory == 'conferences-events' ||
                          toolkitCategory == 'diversity-calendar' ? (
                            <td>{displayEventDates(tool, true)}</td>
                          ) : null}

                          {toolkitCategory === 'all' ||
                          toolkitCategory === 'favorites' ||
                          toolkitCategory === 'archive' ? (
                            <td>{tool.category}</td>
                          ) : null}

                          {toolkitCategory != 'diversity-calendar' ? (
                            <td>
                              {tool.subCategory ? tool.subCategory : 'none'}
                            </td>
                          ) : null}

                          <td>{this.showCategoryTypes(tool, '1')}</td>
                          <td>{this.showCategoryTypes(tool, '2')}</td>
                          <td>
                            {removePhraseBetweenCommas(
                              tool.eventAddress,
                              'CAL Fire'
                            )}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td style={{ borderTop: 'none' }}>
                        <EmptyTable title="No results found" subtitle="" />
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* </table> */}
              </Table>
            </div>
          </div>
        )}

        {selectedResource != null && isGroupModal ? (
          <AddToGroup
            closeGroupModal={this.addGroupModal}
            modelName={'OfficeToolkit'}
            itemType={selectedResource.category}
            itemId={selectedResource._id}
            item={selectedResource}
            isOpen={isGroupModal}
          />
        ) : null}

        {showSlackShare && (
          <SlackSharePopup
            handleSocialShare={this.handleSocialShare}
            slackShared={[]}
            answer={''}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowSlackPopup={(val) => this.setState({ showSlackShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
        {showTeamsShare && (
          <TeamsSharePopup
            handleSocialShare={this.handleSocialShare}
            teamsShared={[]}
            answer={''}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowTeamsPopup={(val) => this.setState({ showTeamsShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dani: state.dani,
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onToolkitSelected: () => dispatch(actionCreators.onToolkitSelected()),
    onChooseCategory: (data) =>
      dispatch(actionCreators.addToolChooseCategorySuccess(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Loading(ToolkitCategory, axios))
)
